import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { axiosPrivate } from "../../Helpers/axios";
import { maskNumber } from "../../utils/maskMobileNum";

function* getTransactionsDataResponse({
  payload: { agentId, page, limit, search, fromDate, toDate, status },
}) {
  try {
    const response = yield call(
      axiosPrivate.get,
      `/api/cou-dashboard/transactions?page=${page ? page : 1}&limit=${
        limit ? limit : 10
      }${search ? `&search=${search}` : ""}${
        status ? `&status=${status}` : ""
      }${
        fromDate ? `&fromDate=${encodeURIComponent(fromDate)}` : ""
      }${toDate ? `&toDate=${encodeURIComponent(toDate)}` : ""}${
        agentId ? `&agentId=${agentId}` : ""
      }`,
    );
    if (response.status === 200) {
      yield put(
        actions.getTransactionsDataSuccess(
          response?.data,
          response?.data?.total,
        ),
      );
    } else {
      yield put(actions.getTransactionsDataFailed(response?.message));
    }
  } catch (error) {
    yield put(
      actions.getTransactionsDataFailed(error?.response?.data?.message),
    );
  }
}

function* getAllTransactionsDataResponse({
  payload: { offset, limit, search, fromDate, toDate, agentId, status },
}) {
  try {
    const response = yield call(
      axiosPrivate,
      `/api/cou-dashboard/transactions?page=${offset ? offset : 1}&limit=${
        limit ? limit : 10
      }${search ? `&search=${search} ` : ""}${
        status ? `&status=${status}` : ""
      }${
        fromDate ? `&fromDate=${fromDate} ` : ""
      }${toDate ? `&toDate=${toDate} ` : ""}${
        agentId ? `&agentId=${agentId}` : ""
      }`,
    );
    if (response.status === 200) {
      yield put(
        actions.getAllTransactionsDataSuccess(
          response?.data,
          response?.data?.total,
        ),
      );
    } else {
      yield put(actions.getAllTransactionsDataFailed(response?.message));
    }
  } catch (error) {
    yield put(
      actions.getAllTransactionsDataFailed(
        error?.response?.data?.message || error,
      ),
    );
  }
}

function* getChartDataResponse({ payload: { agentId } }) {
  try {
    const response = yield call(
      axiosPrivate,
      `/api/cou-dashboard/transactions/graph?${
        agentId ? `agentId=${agentId}` : ""
      }`,
    );
    yield put(actions.getChartDataSuccess(response?.data));
  } catch (error) {
    yield put(actions.getChartDataFailed(error?.response?.data?.message));
  }
}

function* getDailyChartDataResponse({ payload: { agentId } }) {
  try {
    const response = yield call(
      axiosPrivate,
      `/api/cou-dashboard/transactions/daily-graph?${
        agentId ? `agentId=${agentId}` : ""
      }`,
    );
    yield put(actions.getDailyChartDataSuccess(response?.data));
  } catch (error) {
    yield put(actions.getDailyChartDataFailed(error?.response?.data?.message));
  }
}

function* getPieChartDataResponse({ payload: { agentId } }) {
  try {
    const response = yield call(
      axiosPrivate,
      `/api/cou-dashboard/transactions/piechart?${
        agentId ? `agentId=${agentId}` : ""
      }`,
    );
    yield put(actions.getPieChartDataSuccess(response?.data));
  } catch (error) {
    yield put(actions.getPieChartDataFailed(error?.response?.data?.message));
  }
}

function* getFullTransactionDetails({ payload: { refId } }) {
  try {
    const response = yield call(
      axiosPrivate,
      `/api/cou-dashboard/transactions/full-transaction-history/${refId}`,
    );
    if (response.status === 201 || response.status === 200) {
      response.data.request.customerMobile = maskNumber(
        response.data.request.customerMobile,
      );
      yield put(actions.getFullTransactionsDetailsSuccess(response?.data));
    } else {
      yield put(actions.getFullTransactionDetailsError(response));
    }
  } catch (error) {
    yield put(actions.getFullTransactionDetailsError(error));
  }
}

function* getLogger({ payload: { page, limit, search } }) {
  try {
    console.log("bug", page, limit, search);
    let url;
    if (search) {
      url = `/cou-dashboard/logger/logs?page=${page || 1}&limit=${
        limit || 10
      }&search=${search}`;
    } else {
      url = `/cou-dashboard/logger/logs?page=${page || 1}&limit=${limit || 10}`;
    }
    const response = yield call(axiosPrivate, url);
    if (response.status === 201 || response.status === 200) {
      yield put(actions.getLoggerDataSuccess(response?.data));
    } else {
      yield put(actions.getLoggerDataFailed(response));
    }
  } catch (error) {
    yield put(actions.getLoggerDataFailed(error));
  }
}

function* fetchAgentInfo({ payload: { agentId } }) {
  try {
    const response = yield call(
      axiosPrivate,
      `/api/cou-dashboard/transactions/agent-info?agentId=${agentId}`,
    );
    if (response.status === 201 || response.status === 200) {
      yield put(actions.fetchAgentInfoSuccess(response?.data));
    } else {
      yield put(actions.fetchAgentInfoFailed(response));
    }
  } catch (error) {
    yield put(actions.fetchAgentInfoFailed(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_TRANSACTIONS_DATA, getTransactionsDataResponse),
  ]);
  yield all([
    takeEvery(
      actions.GET_ALL_TRANSACTIONS_DATA,
      getAllTransactionsDataResponse,
    ),
  ]);
  yield all([takeEvery(actions.GET_CHART_DATA, getChartDataResponse)]);
  yield all([
    takeEvery(actions.GET_DAILY_CHART_DATA, getDailyChartDataResponse),
  ]);
  yield all([
    takeEvery(actions.GET_FULL_TRANSACTIONS_DETAILS, getFullTransactionDetails),
  ]);
  yield all([takeEvery(actions.GET_LOGGER_DATA, getLogger)]);
  yield all([takeEvery(actions.GET_PIE_CHART_DATA, getPieChartDataResponse)]);
  yield all([takeEvery(actions.FETCH_AGENT_INFO, fetchAgentInfo)]);
}
